export default __webpack_public_path__ + "static/media/CNo.82-6.3e095854.jpg";